import { CartProcessingStrategy, CartState } from "../interfaces";
import { CartQuery } from "../../lib/api";

const MIN_QUANTITY = 0;
const MAX_QUANTITY = 99;

export class DefaultCartProcessingStrategy implements CartProcessingStrategy {
  supports(cart: CartQuery['Cart']) {
    return true;
  }

  incrementQuantity(productId: string, state: CartState) {
    return this.modifyQuantity(state, productId, 1);
  }

  decrementQuantity(productId: string, state: CartState) {
    return this.modifyQuantity(state, productId, -1);
  }

  onDiscountApplied(state: CartState) {
    return { selectedQuantities: { ...state.selectedQuantities } }
  }

  protected modifyQuantity(state: CartState, productId: string, change: number) {
    const updatedQty = Math.max(state.selectedQuantities[productId] + change, MIN_QUANTITY);

    return {
      selectedQuantities: {
        ...state.selectedQuantities,
        [productId]: Math.min(updatedQty, MAX_QUANTITY),
      },
    };
  }
}
